/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError, AxiosResponse, AxiosHeaders } from "axios";
import { api } from "../config";
import { web3 } from "../web3";
import { web3Services } from "./web3.service";
import { uploadToS3, deleteToS3 } from "../s3.service";
import { generateUserKey } from "./sessionKey";

interface Headers {
  "content-type": string;
  "x-auth-token"?: string;
}

interface Web3Data {
  isLoggedIn: boolean;
  accounts: string[];
}

interface S3UploadResponse {
  Location: string;
}

const convertHeadersToAxiosHeaders = (
  headers?: Headers,
): Record<string, string> => {
  const axiosHeaders: Record<string, string> = {};
  if (headers) {
    for (const [key, value] of Object.entries(headers)) {
      axiosHeaders[key] = value;
    }
  }
  return axiosHeaders;
};

export const backendServices = {
  async post<T>(
    url: string,
    params: any,
    header?: Headers,
  ): Promise<AxiosResponse<T>> {
    try {
      const result = await generateUserKey();
      const userKey = result.userKey;
      const token = localStorage.getItem("token");

      const headers = {
        ...header, // Spread existing headers
      };

      if (token) {
        headers["x-auth-token"] = token;
      }

      if (userKey) {
        headers["sessionKey"] = userKey;
      }

      const response = await api.post<T>(url, params, {
        headers: convertHeadersToAxiosHeaders(headers),
      });
      return response;
    } catch (error) {
      const err = error as AxiosError;
      if (err.response) {
        throw err.response;
      } else if (err.request) {
        throw err.request;
      } else if (err.message) {
        throw new Error(err.message);
      }
      throw error;
    }
  },

  async get<T>(url: string, header?: Headers): Promise<AxiosResponse<T>> {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "content-type": "application/json",
        ...header,
      };
      if (token) {
        headers["x-auth-token"] = token;
      }
      const response = await api.get<T>(url, {
        headers: convertHeadersToAxiosHeaders(headers),
      });
      return response;
    } catch (error) {
      throw error as Error;
    }
  },

  async put<T>(
    url: string,
    parameters: any,
    header?: Headers,
  ): Promise<AxiosResponse<T>> {
    try {
      const token = localStorage.getItem("token");
      const result = await generateUserKey();
      const userKey = result.userKey;

      const headers = {
        ...header, // Spread existing headers
      };

      if (token) {
        headers["x-auth-token"] = token;
      }

      if (userKey) {
        headers["sessionKey"] = userKey;
      }

      const response = await api.put<T>(url, parameters, {
        headers: convertHeadersToAxiosHeaders(headers),
      });
      return response;
    } catch (error) {
      throw error as Error;
    }
  },

  async delete<T>(url: string, header?: Headers): Promise<AxiosResponse<T>> {
    try {
      const token = localStorage.getItem("token");
      const result = await generateUserKey();
      const userKey = result.userKey;

      const headers = {
        "content-type": "application/json",
        ...header,
      };

      if (token) {
        headers["x-auth-token"] = token;
      }

      if (userKey) {
        headers["sessionKey"] = userKey;
      }

      const response = await api.delete<T>(url, {
        headers: convertHeadersToAxiosHeaders(headers),
      });
      return response;
    } catch (error) {
      throw error as Error;
    }
  },

  async getWeb3(): Promise<Web3Data | undefined> {
    if (web3) {
      let web3Data: Web3Data = {
        isLoggedIn: false,
        accounts: [],
      };
      try {
        const accounts = await web3.eth.getAccounts();

        if (accounts.length === 0) {
          await web3Services.enableMetamask();
        } else {
          web3Data.isLoggedIn = true;
          web3Data.accounts = accounts;
        }

        return web3Data;
      } catch (error) {
        return web3Data;
      }
    }
  },

  async uploadFileOnBucket(
    file: File,
    folder: string,
  ): Promise<string | false> {
    try {
      const extension = file.name.split(".").pop()?.toLowerCase() || "";
      const uploadTo = (await uploadToS3(
        `${folder}-${+new Date()}`,
        file,
        folder,
        extension,
      )) as S3UploadResponse;
      return uploadTo.Location;
    } catch (error) {
      return false;
    }
  },

  async remoeveFileOnBucket(fileName: string): Promise<true | false> {
    try {
      await deleteToS3(fileName);
      return true;
    } catch (error) {
      return false;
    }
  },

  async updateAssetResellStatus(assetId: string): Promise<AxiosResponse<any>> {
    try {
      const result = await generateUserKey();
      const userKey = result.userKey;
      const token = localStorage.getItem("token");

      const headers = {
        "content-type": "application/json",
      };

      if (token) {
        headers["x-auth-token"] = token;
      }

      if (userKey) {
        headers["sessionKey"] = userKey;
      }

      const response = await api.put(
        `admin/asset/${assetId}/enable-resell`,
        {},
        {
          headers: convertHeadersToAxiosHeaders(headers),
        },
      );
      return response;
    } catch (error) {
      throw error as Error;
    }
  },
};
